import React from 'react';
import ReactModal from 'react-modal';
import cx from 'classnames';
import ModalDialog from '../ModalDialog';

const Modal = ({
  isOpen = false,
  onOpen = () => {},
  onClose = () => {},
  contentLabel = 'Modal',
  children,
  dialogClassName = '',
  overlayClassName = '',
  parentSelector = 'body',
  defaultLayout = true,
}) => {
  // computing the class names for overlay and dialog
  const computedOverlayClassName = {
    base: cx('c-modal-underlay', overlayClassName),
    afterOpen: 'is-visible',
  };

  const computedDialogClassName = {
    base: cx('c-modal-dialog', dialogClassName),
    afterOpen: 'is-visible',
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onOpen}
      onRequestClose={onClose}
      contentLabel={contentLabel}
      className={computedDialogClassName}
      parentSelector={() => document.querySelector(parentSelector)}
      overlayClassName={computedOverlayClassName}
    >
      {defaultLayout && <ModalDialog onClose={onClose}>{children}</ModalDialog>}

      {!defaultLayout && children}
    </ReactModal>
  );
};

export default Modal;
